<div class="content">
  <h2>Kontaktdaten der Westnetz GmbH</h2>

  <mat-accordion multi="true">
    @for (schaltleitung of schaltleitungen$ | async; track schaltleitung.id) {
      <mat-expansion-panel
        data-qa="kontaktdaten-body">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{schaltleitung.name}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field>
          <mat-label>Kürzel</mat-label>
          <input matInput
            [disabled]="true"
            [ngModel]="schaltleitung.kuerzel"
            />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput
            [disabled]="true"
            [ngModel]="schaltleitung.name"/>
        </mat-form-field>
        <mat-form-field class="wider-form-field">
          <mat-label>Adresse</mat-label>
          <input matInput
            [disabled]="true"
            [ngModel]="schaltleitung.adresse"/>
        </mat-form-field>
        <h4>Kontaktinformationen</h4>
        <table class="kontaktinformationen-table">
          <tr>
            <td>E-Mail:</td>
            <td>{{schaltleitung.email}}</td>
          </tr>
          @for (kontakt of schaltleitung.kontakte; track kontakt) {
            <tr>
              <td>{{kontakt.type}}@if (kontakt.type) {
                :
              }</td>
              <td>{{kontakt.data}}</td>
            </tr>
          }
        </table>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <p>
    <mat-icon>security</mat-icon>
    Die individuellen Anwahlnummern der Direktleitungen sowie die Faxnummern und E-Mail-Adressen sind streng
    vertraulich zu behandeln und dürfen nicht weitergegeben werden.
  </p>
  <p>
    <mat-icon>warning</mat-icon>
    Für den Fall, dass das TNB-Portal temporär nicht erreichbar ist, müssen die angegebenen Kontaktdaten
    krisensicher abgelegt werden.
  </p>
</div>

